<div *ngIf="!isLoading; else loading">
  <div
    class="heading w-full flex justify-between p-2"
    *ngIf="selectedBonusEvent as bonusEvent; else createBonusEventHeader"
  >
    <div class="flex flex-col">
      <div class="ml-3 text-xl">
        {{ bonusEvent.name }}
      </div>
      <div class="ml-3 text-sm">Created On {{ bonusEvent.createdAt | date: 'medium' }}</div>
    </div>
    <div class="flex flex-row" *ngIf="!isDisableForm">
      <div class="self-end">
        <button mat-raised-button color="primary" (click)="onSave()" [disabled]="isSaving">SAVE</button>
      </div>
      <div class="ml-2 self-end">
        <button mat-raised-button color="warn" (click)="endBonusEvent()" [disabled]="isSaving">END</button>
      </div>
    </div>
  </div>
  <ng-template #createBonusEventHeader>
    <div class="heading w-full flex justify-between p-2">
      <div class="flex flex-col">
        <div class="ml-3 text-xl">
          Create Bonus Event
        </div>
      </div>
      <div class="flex flex-row">
        <div class="self-end">
          <button mat-raised-button color="primary" (click)="onSave()" [disabled]="isSaving">SAVE</button>
        </div>
      </div>
    </div>
  </ng-template>

  <div class="m-2">
    <mat-card>
      <a class="flex text-blue-700" [routerLink]="['/', 'bonus-event', backTab]">
        <mat-icon>arrow_back</mat-icon>
        Back to List
      </a>
      <hr class="mt-2" />

      <div class="grid grid-cols-4 gap-2 mt-2" *ngIf="selectedBonusEvent as bonusEvent; else createBonusEventForm">
        <div class="col-span-3 grid gap-3 grid-flow-row auto-rows-min">
          <div>
            <sa-bonus-event-summary [selectedBonusEvent]="bonusEvent"></sa-bonus-event-summary>
          </div>
          <div>
            <sa-bonus-event-detail [selectedBonusEvent]="bonusEvent" [type]="type"></sa-bonus-event-detail>
          </div>
        </div>
        <div class="col-span-1 flex flex-col h-screen">
          <sa-bonus-event-order [selectedBonusEvent]="bonusEvent"></sa-bonus-event-order>
        </div>
      </div>

      <ng-template #createBonusEventForm>
        <div class="grid grid-cols-4 gap-2 mt-2">
          <div class="col-span-3 grid gap-3 grid-flow-row auto-rows-min">
            <div>
              <sa-bonus-event-detail [selectedBonusEvent]="selectedBonusEvent"></sa-bonus-event-detail>
            </div>
          </div>
        </div>
      </ng-template>
    </mat-card>
  </div>
</div>
<ng-template #loading>
  <div class="heading w-full flex justify-between p-2">
    <div class="flex flex-col">
      <div class="ml-3 text-xl">
        Bonus Event
      </div>
    </div>
  </div>
  <mat-spinner diameter="24"></mat-spinner>
</ng-template>
